import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrandMaintenanceComponent } from './brand-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: BrandMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BrandMaintenanceRoutingModule { }
